import { render, staticRenderFns } from "./SlideWaiting.vue?vue&type=template&id=229988d1&scoped=true&"
import script from "./SlideWaiting.vue?vue&type=script&lang=js&"
export * from "./SlideWaiting.vue?vue&type=script&lang=js&"
import style0 from "./SlideWaiting.vue?vue&type=style&index=0&id=229988d1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229988d1",
  null
  
)

export default component.exports